import { ICommonResponse } from "../core/api/http-methods/common-response.type";
import { IEntityDetails, IEntityLocation } from "../types/entity.types";
import apiClient from "./client";

export const getEntityDetails = async (entity_id: string) => {
    return (await apiClient.get<ICommonResponse<IEntityDetails>>(`/entity/${entity_id}`)).data;
}

export const getBrandLocations = async (entity_id: string, payload: { page: number;  limit: number; search?: string }) => {
    return (await apiClient.post<ICommonResponse<IEntityLocation[]>>(`/entity/${entity_id}/locations`, payload)).data;
}
